import { useForm } from 'react-hook-form'
import { postTeachersSignIn } from '../apis/teacher.ts'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getSchools } from '../apis/school.ts'
import { postStudentsSignIn } from '../apis/student.ts'

export default function TestLogin() {
  const { register, handleSubmit } = useForm()
  const navigate = useNavigate()
  const [schoolId, setSchoolId] = useState()
  //   const setLogin = useSetRecoilState(loginState)

  useEffect(() => {
    getSchoolsApi()
  }, [])

  const getSchoolsApi = async () => {
    const getSchoolsResponse = await getSchools()

    if (getSchoolsResponse.error) {
      console.log(getSchoolsResponse)
      return
    } else {
      setSchoolId(getSchoolsResponse.data[1].id)
    }
  }

  const onTeacherSubmit = async (data) => {
    const postTeachersSignInResponse = await postTeachersSignIn({
      userId: data.userId,
      password: data.teacherPassword,
    })
    if (postTeachersSignInResponse.error) {
      console.log(postTeachersSignInResponse.message)
      return
    }
    alert('선생님 로그인되었습니다.')
    navigate('/class')
    // reset()
    // setLogin({ isLoggedIn: true })
    // reset()
  }
  const onStudentSubmit = async (data) => {
    const postStudentsSignInResponse = await postStudentsSignIn({
      grade: data.grade,
      classNumber: data.classNumber,
      studentNumber: data.studentNumber,
      password: data.password,
      schoolId: schoolId,
    })
    if (postStudentsSignInResponse.error) {
      console.log(postStudentsSignInResponse.message)
      return
    }
    alert('학생 로그인되었습니다.')
    navigate('/class')
    // reset()
    // setLogin({ isLoggedIn: true })
    // reset()
  }
  return (
    <>
      <form onSubmit={handleSubmit(onTeacherSubmit)}>
        <p>선생님</p>
        <p>ID</p>
        <input {...register('userId')} className='input_default' type='text' />
        <p>PASSWORD</p>
        <input {...register('teacherPassword')} className='input_default' type='text' />
        <button className='button_solid_primary_md' type='submit'>
          Login
        </button>
      </form>
      <form onSubmit={handleSubmit(onStudentSubmit)}>
        <p>학생</p>
        <p>학년</p>
        <input {...register('grade')} className='input_default' type='text' />
        <p>반</p>
        <input {...register('classNumber')} className='input_default' type='text' />
        <p>번호</p>
        <input {...register('studentNumber')} className='input_default' type='text' />
        <p>PASSWORD</p>
        <input {...register('password')} className='input_default' type='text' />
        <button className='button_solid_primary_md' type='submit'>
          Login
        </button>
      </form>
    </>
  )
}
